import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'

import CityPlanView from '../../Containers/Campaigns/CityPlanView'
import RosterView from '../../Containers/Campaigns/RosterView'
import CityPlanEdit from '../../Containers/Campaigns/CityPlanEdit'

import { AdminRoute, PrivateRoute } from '../../Config/Routing/auth'

import { PATHS } from '../../Config/Routing/paths'
import LetterboxMissions from '../../Containers/LetterboxMissions/container/LetterboxMissions'
import useGraphQLFetch from '../../Utils/Hooks/useGraphQLFetch'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'

import { mockRosters } from '../../Utils/Mission'
import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const CityPlanRouter = props => {
  const { campaignId, cityPlanId, rosterId } = props.match.params
  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getCityPlanData,
    defaultFetchArgs: { campaignId, cityPlanId },
    mapResponse: data => formatData(data, cityPlanId),
  })

  if (!isLoaded) return 'Loading...'

  return (
    <Switch>
      <Route exact path={props.match.path}>
        <PrivateRoute>
          <CityPlanView {...props} {...data} />
        </PrivateRoute>
      </Route>
      <Route
        exact
        path={`${props.match.path}${PATHS.cityPlan.letterboxMissions}`}
      >
        <PrivateRoute>
          <LetterboxMissions
            refetchMissions={(args = {}) =>
              refetch({ campaignId, cityPlanId, ...args })
            }
            {...props}
            {...data}
          />
        </PrivateRoute>
      </Route>
      <Route exact path={`${props.match.path}${PATHS.cityPlan.rosterView}`}>
        <PrivateRoute>
          <RosterView
            {...props}
            {...data}
            missions={rosterId && getRostersMissions(rosterId, data.rosters)}
            refetchMissions={(args = {}) =>
              refetch({ campaignId, cityPlanId, ...args })
            }
          />
        </PrivateRoute>
      </Route>
      <Route exact path={`${props.match.path}${PATHS.cityPlan.cityPlanEdit}`}>
        <AdminRoute>
          <CityPlanEdit {...props} {...data} />
        </AdminRoute>
      </Route>
    </Switch>
  )
}

const getCityPlanData = async ({ campaignId, cityPlanId }) => {
  const query = `query 
    (
    $campaignId:ID!
    $cityPlanId:ID
    ) {
      campaign(id:$campaignId){
        id
        name
        type
        status
        metrics {
          nodes {
            id
            name
            targetConversionRate
            targetCostPerMetric
            isPrimary 
          }
        }
        cityPlans(cityPlanId:$cityPlanId) {
          nodes {
            id
            teamLeaderPayAdjustment
            hourlyPayout
            clientMarginPercent
            distributionCost
            payout
            missions {
              edges {
                node {
                  id
                  flyerCode
                  status
                  totalFlyersDistributed
                  dateTime
                  distributionCost
                  draftPayAdjustment
                  printingCostPerFlyer
                  bonusPerConversion
                  bonusRedemptionPeriod
                  cancelled
                  automatic
                  type
                  boundaryColour
                  label
                  packSize
                  boundary {
                    latitude
                    longitude
                  }
                  user {
                    id
                    firstName
                    lastName
                  }
                  location {
                    id
                    name
                    detailedRank
                  }
                  costPerFlyer
                  amountScans
                  canBeSpied
                }
              }
            }
            city {
              id
              name
              latitude
              longitude
              lunchCheckInTime
              afternoonCheckInTime
              teamLeaderEnabled
              locations{
                edges {
                  node {
                    id
                    name
                    longitude
                    latitude
                  }
                }
              }
              country {
                code
                currencySign 
              }
            }
          }
        }
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    cityPlanId,
  })
}

const formatData = ({ campaign: campaignData }, cityPlanId) => {
  if (!campaignData) {
    return {
      campaign: {},
      cityPlan: {},
      rosters: [],
      metrics: [],
      missions: [],
    }
  }
  const cityPlans = campaignData.cityPlans.nodes
  const missions = cityPlans.reduce(
    (acc, cityPlan) => [
      ...acc,
      ...normalizeGraphQLConnection(cityPlan.missions),
    ],
    [],
  )

  const cityPlan = cityPlans.find(({ id }) => id === cityPlanId)
  const cityPlanMissions = normalizeGraphQLConnection(cityPlan.missions)
  const rosters = mockRosters(cityPlanMissions)

  return {
    campaign: campaignData,
    cityPlan: {
      ...cityPlan,
      missions: cityPlanMissions,
    },
    city: cityPlan.city,
    rosters,
    missions,
    countryCode: cityPlan.city.country.code,
  }
}

const getRostersMissions = (rosterId, rosters) => {
  const [year, week] = rosterId.split('-')
  const roster = rosters.find(
    roster => roster.weekNum == week && roster.year == year,
  )
  return roster && roster.missions ? roster.missions : []
}

export default withRouter(CityPlanRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/CityPlanRouter.js